import React, { useState } from 'react';
import parse from "html-react-parser";

const TextTruncate = (props) => {

  const handleReadMore = (e) => {
    e.preventDefault();
    e.target.parentNode.previousSibling.innerHTML = props.textCopy;
    e.target.parentNode.previousSibling.classList.remove('truncate');
    e.target.classList.add('hidden');
  };

  return (
    <div className='text-truncate'>
      <div className='truncate'>
        {parse(props.previewCopy)}
      </div>
      <div className='show-more'>
        {drupalSettings.editFlag && 
          <>
            <a href = {`/node/` + props.nid + `/edit`} target='_blank' className='edit-link'>Edit</a> 
          </>
        }
        <a href='#' onClick={handleReadMore}>
          {props.showMoreLabel}
        </a>
      </div>
    </div>
  );
};

export default TextTruncate;